import { render } from "./Confirmation.vue.js?vue&type=template&id=0c072e35!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Confirmation.vue?vue&type=template&id=0c072e35"
import script from "./Confirmation.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Confirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__